<template lang="pug">
.l-container.is-lg
  info(:event="event")
  completed(v-if="event.entry && (!event.vgt_day2 || event.vgt_day2.entry)" :event="event")
  common-form(v-else :event="event" :occupations="occupations" :commonFormSubmit="eventEntry" :workExperiences="workExperiences" :videoProductionMinds="videoProductionMinds" :jobCategories="jobCategories" :videoCategories="videoCategories")
    Vgt2022(v-if="event.slug.startsWith('vgt2022')")
    Nikon20230809(v-else-if="event.slug === 'Nikon20230809'" :slug="event.slug")
    Nikon202309(v-else-if="event.slug === 'n20230904'" :slug="event.slug")
    Nikon20230923(v-else-if="event.slug === 'Nikon20230923'" :slug="event.slug")
    Nikon20231101(v-else-if="event.slug === 'Nikon20231101'" :slug="event.slug")
    Default(v-else)
</template>

<script>
import Info from '~/components/events/Info'
import Completed from '~/components/events/Completed'
import CommonForm from '~/components/events/CommonForm'
import Vgt2022 from '~/components/events/enquetes/Vgt2022'
import Default from '~/components/events/enquetes/Default'
import Nikon20230809 from '~/components/events/enquetes/Nikon20230809'
import Nikon202309 from '~/components/events/enquetes/Nikon202309'
import Nikon20230923 from '~/components/events/enquetes/Nikon20230923'
import Nikon20231101 from '~/components/events/enquetes/Nikon20231101'
import Meta from '~/assets/mixins/meta'

export default {
  components: {
    Info,
    Completed,
    CommonForm,
    Vgt2022,
    Nikon20230809,
    Nikon202309,
    Nikon20230923,
    Nikon20231101,
    Default
  },
  mixins: [Meta],
  async asyncData({ params, $axios, redirect, error }) {
    const event = await $axios.$get(`/events/${params.slug}`)
    if (!event.has_enquete) {
      redirect(`/events/${params.slug}`)
    }
    const {
      generals: {
        occupation: occupations,
        work_experience: workExperiences,
        video_production_mind: videoProductionMinds,
        job_category: jobCategories,
        video_category: videoCategories
      }
    } = await $axios.$get('/master_data/generals/all')
    return {
      event,
      occupations,
      workExperiences,
      videoProductionMinds,
      jobCategories,
      videoCategories,
      formData: null,
      meta: {
        title: event.name
      }
    }
  },
  methods: {
    eventEntry(fee) {
      if (fee === 0) {
        this.$router.push(`/events/${this.event.slug}/confirm`)
      } else {
        // MEMO: $router.pushだとSPAのためPay.jpがインスタンス重複作成エラーになる
        location.href = `/events/${this.event.slug}/credit_form`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.l-container {
  @include page();
  @include media(sp) {
    padding: 10px 0 20px;
  }
}
</style>
